import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Player from "../components/description/Player";
import VideoDescription from "../components/description/VideoDescription";
import RelatedVideoList from "../components/list/RelatedVideoList";
import Loading from "../components/ui/Loading";
import { fetchVideo } from "../features/video/videoSlice";

const Video = () => {
    const dispatch = useDispatch();
    const { video, isLoading, isError, error } = useSelector(
        (state) => state.video
    );
    const { videoId } = useParams();

    useEffect(() => {
        dispatch(fetchVideo(videoId));
    }, [dispatch, videoId]);

    const { id, link, title, tags } = video || {};

    // decide what to render
    let content = null;

    if (isLoading)
        content = (
            <div className="w-20 ml-[350px] mt-[150px]">
                <Loading />
            </div>
        );

    if (!isLoading && isError)
        content = (
            <div className="col-span-12  text-red-400 text-xl font-medium">
                {error}
            </div>
        );

    if (!isLoading && !isError && id)
        content = <div className="col-span-12">No video found.</div>;

    if (!isLoading && !isError && id)
        content = (
            <div className="grid grid-cols-3 gap-2 lg:gap-8">
                <div className="col-span-full w-full space-y-2 lg:col-span-2">
                    <Player link={link} title={title} />

                    <VideoDescription video={video} />
                </div>

                <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto">
                    <RelatedVideoList tags={tags} currentVideoId={id} />
                </div>
            </div>
        );

    return (
        <section className="pt-6 pb-20">
            <div className="mx-auto max-w-7xl px-2 pb-20 min-h-[400px]">
                {content}
            </div>
        </section>
    );
};

export default Video;
